<div class="page-container account-grouping-container container">
  <app-breadcrumb [crumbConfig]="crumbConfig" />

  @if (groupId === '') {
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
      (deleteItem)="deleteGroup($event)"
    >
      <span class="approval-container">
        <button
          type="button"
          mat-raised-button
          color="primary"
          class="custom-grid-control me-0 ms-2"
          (click)="createNewGroup()"
        >
          <mat-icon class="me-2">group_add</mat-icon>New Group
        </button>
      </span>
    </app-rb-grid>
  } @else {
    <app-account-grouping-detail [groupId]="groupId" />
  }
</div>
